export function getRiskCommandsOrThrow(riskCommandsRef, callerName, requiredCommands = []) {
    const commands = riskCommandsRef?.current;
    if (!commands) {
        throw new Error(`${callerName} requires riskCommandsRef.current`);
    }

    requiredCommands.forEach((commandName) => {
        if (typeof commands[commandName] !== 'function') {
            throw new Error(`${callerName} requires riskCommandsRef.current.${commandName}`);
        }
    });

    return commands;
}
